<script>
import { mapState } from "vuex";

export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: null,
      hivAids: 0,
      alzheimersDementia: 0,
      alcoholDrugAbuse: 0,
      asthma: 0,
      cancer: 0,
      clinicalDepression: 0,
      diabetes: 0,
      emphysema: 0,
      epilepsy: 0,
      heartAttack: 0,
      hepatitisLiver: 0,
      highBloodPressure: 0,
      highCholesterol: 0,
      kidneyDisease: 0,
      mentalIllness: 0,
      multipleSclerosis: 0,
      other: 0,
      pulmonaryDisease: 0,
      stroke: 0,
      ulcers: 0,
      vascularDisease: 0,
      heartDisease: 0,
    };
  },

  computed: {
    ...mapState([
      'fields',
      'fieldsFromStorage',
    ])
  },

  created() {
    this.answers = {
      'Continue': [
        { field: "major_condition_alcohol_drug_abuse", value: 0 },
        { field: "major_condition_alzheimers_dementia", value: 0 },
        { field: "major_condition_asthma", value: 0 },
        { field: "major_condition_cancer", value: 0 },
        { field: "major_condition_clinical_depression", value: 0 },
        { field: "major_condition_diabetes", value: 0 },
        { field: "major_condition_emphysema", value: 0 },
        { field: "major_condition_epilepsy", value: 0 },
        { field: "major_condition_heart_attack", value: 0 },
        { field: "major_condition_heart_disease", value: 0 },
        { field: "major_condition_hepatitis_liver", value: 0 },
        { field: "major_condition_high_blood_pressure", value: 0 },
        { field: "major_condition_high_cholesterol", value: 0 },
        { field: "major_condition_hiv_aids", value: 0 },
        { field: "major_condition_kidney_disease", value: 0 },
        { field: "major_condition_mental_illness", value: 0 },
        { field: "major_condition_multiple_sclerosis", value: 0 },
        { field: "major_condition_condition_other", value: 0 },
        { field: "major_condition_pulmonary_disease", value: 0 },
        { field: "major_condition_stroke", value: 0 },
        { field: "major_condition_ulcers", value: 0 },
        { field: "major_condition_vascular_disease", value: 0 },
      ],
    }

    if (this.prepare) {
      if (this.fields['preexistingcondition'] === "No") {
        this.$emit('next-step')
        return
      }

      if (!(this.fieldsFromStorage["major_condition_alcohol_drug_abuse"] === undefined)) {
        this.setAnswer(
          this.alcoholDrugAbuse = this.fieldsFromStorage['major_condition_alcohol_drug_abuse'],
          this.alzheimersDementia = this.fieldsFromStorage['major_condition_alzheimers_dementia'],
          this.asthma = this.fieldsFromStorage['major_condition_asthma'],
          this.cancer = this.fieldsFromStorage['major_condition_cancer'],
          this.clinicalDepression = this.fieldsFromStorage['major_condition_clinical_depression'],
          this.diabetes = this.fieldsFromStorage['major_condition_diabetes'],
          this.emphysema = this.fieldsFromStorage['major_condition_emphysema'],
          this.epilepsy = this.fieldsFromStorage['major_condition_epilepsy'],
          this.heartAttack = this.fieldsFromStorage['major_condition_heart_attack'],
          this.heartDisease = this.fieldsFromStorage['major_condition_heart_disease'],
          this.hepatitisLiver = this.fieldsFromStorage['major_condition_hepatitis_liver'],
          this.highBloodPressure = this.fieldsFromStorage['major_condition_high_blood_pressure'],
          this.highCholesterol = this.fieldsFromStorage['major_condition_high_cholesterol'],
          this.hivAids = this.fieldsFromStorage['major_condition_hiv_aids'],
          this.kidneyDisease = this.fieldsFromStorage['major_condition_kidney_disease'],
          this.mentalIllness = this.fieldsFromStorage['major_condition_mental_illness'],
          this.multipleSclerosis = this.fieldsFromStorage['major_condition_multiple_sclerosis'],
          this.other = this.fieldsFromStorage['major_condition_condition_other'],
          this.pulmonaryDisease = this.fieldsFromStorage['major_condition_pulmonary_disease'],
          this.stroke = this.fieldsFromStorage['major_condition_stroke'],
          this.ulcers = this.fieldsFromStorage['major_condition_ulcers'],
          this.vascularDisease = this.fieldsFromStorage['major_condition_vascular_disease'],
          )
        return
      }

      this.$emit('show-this-step')
    }
  },

  methods: {
    setAnswer(answer) {
      this.loading = answer;
      this.$store.dispatch("setAnswers", [
        { field: "major_condition_alcohol_drug_abuse", value: this.alcoholDrugAbuse },
        { field: "major_condition_alzheimers_dementia", value: this.alzheimersDementia },
        { field: "major_condition_asthma", value: this.asthma },
        { field: "major_condition_cancer", value: this.cancer },
        { field: "major_condition_clinical_depression", value: this.clinicalDepression },
        { field: "major_condition_diabetes", value: this.diabetes },
        { field: "major_condition_emphysema", value: this.emphysema },
        { field: "major_condition_epilepsy", value: this.epilepsy },
        { field: "major_condition_heart_attack", value: this.heartAttack },
        { field: "major_condition_heart_disease", value: this.heartDisease },
        { field: "major_condition_hepatitis_liver", value: this.hepatitisLiver },
        { field: "major_condition_high_blood_pressure", value: this.highBloodPressure },
        { field: "major_condition_high_cholesterol", value: this.highCholesterol },
        { field: "major_condition_hiv_aids", value: this.hivAids },
        { field: "major_condition_kidney_disease", value: this.kidneyDisease },
        { field: "major_condition_mental_illness", value: this.mentalIllness },
        { field: "major_condition_multiple_sclerosis", value: this.multipleSclerosis },
        { field: "major_condition_condition_other", value: this.other },
        { field: "major_condition_pulmonary_disease", value: this.pulmonaryDisease },
        { field: "major_condition_stroke", value: this.stroke },
        { field: "major_condition_ulcers", value: this.ulcers },
        { field: "major_condition_vascular_disease", value: this.vascularDisease },
      ]);
      this.$emit("next-step");
    },
  },
};
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question mb-3">
          Select which conditions you have been diagnosed with:
        </h2>
        <form
          class="container is-max-widescreen answers-box"
          @submit.prevent="setAnswer('Continue')"
        >
          <b-button
            class="answer-button"
            :loading="loading === 'HIV/AIDS'"
            :disabled="loading !== null"
            @click="hivAids = +!hivAids"
            :class="{ active: hivAids }"
            >
            HIV/AIDS
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Alzheimer\'s or Dementia'"
            :disabled="loading !== null"
            @click="alzheimersDementia = +!alzheimersDementia"
            :class="{ active: alzheimersDementia }"
            >
           Alzheimer's or Dementia
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Alcohol or Drug Abuse'"
            :disabled="loading !== null"
            @click="alcoholDrugAbuse = +!alcoholDrugAbuse"
            :class="{ active: alcoholDrugAbuse }"
            >
            Alcohol or Drug Abuse
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Asthma'"
            :disabled="loading !== null"
            @click="asthma = +!asthma"
            :class="{ active: asthma }"
            >
           Asthma
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Cancer'"
            :disabled="loading !== null"
            @click="cancer = +!cancer"
            :class="{ active: cancer }"
            >
           Cancer
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Clinical Depression'"
            :disabled="loading !== null"
            @click="clinicalDepression = +!clinicalDepression"
            :class="{ active: clinicalDepression }"
            >
           Clinical Depression
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Diabetes'"
            :disabled="loading !== null"
            @click="diabetes = +!diabetes"
            :class="{ active: diabetes }"
            >
           Diabetes
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Emphysema'"
            :disabled="loading !== null"
            @click="emphysema = +!emphysema"
            :class="{ active: emphysema }"
            >
           Emphysema
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Epilepsy'"
            :disabled="loading !== null"
            @click="epilepsy = +!epilepsy"
            :class="{ active: epilepsy }"
            >
           Epilepsy
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Heart Attack'"
            :disabled="loading !== null"
            @click="heartAttack = +!heartAttack"
            :class="{ active: heartAttack }"
            >
           Heart Attack
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Heart Disease'"
            :disabled="loading !== null"
            @click="heartDisease = +!heartDisease"
            :class="{ active: heartDisease }"
            >
           Heart Disease
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Hepatitis'"
            :disabled="loading !== null"
            @click="hepatitisLiver = +!hepatitisLiver"
            :class="{ active: hepatitisLiver }"
            >
            Hepatitis
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'High Blood Pressure'"
            :disabled="loading !== null"
            @click="highBloodPressure = +!highBloodPressure"
            :class="{ active: highBloodPressure }"
            >
            High Blood Pressure
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'High Cholesterol'"
            :disabled="loading !== null"
            @click="highCholesterol = +!highCholesterol"
            :class="{ active: highCholesterol }"
            >
            High Cholesterol
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Kidney Disease'"
            :disabled="loading !== null"
            @click="kidneyDisease = +!kidneyDisease"
            :class="{ active: kidneyDisease }"
            >
            Kidney Disease
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Mental Illness'"
            :disabled="loading !== null"
            @click="mentalIllness = +!mentalIllness"
            :class="{ active: mentalIllness }"
            >
            Mental Illness
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Multiple Sclerosis'"
            :disabled="loading !== null"
            @click="multipleSclerosis = +!multipleSclerosis"
            :class="{ active: multipleSclerosis }"
            >
            Multiple Sclerosis
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Pulmonary Disease'"
            :disabled="loading !== null"
            @click="pulmonaryDisease = +!pulmonaryDisease"
            :class="{ active: pulmonaryDisease }"
            >
            Pulmonary Disease
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Stroke'"
            :disabled="loading !== null"
            @click="stroke = +!stroke"
            :class="{ active: stroke }"
            >
            Stroke
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Ulcers'"
            :disabled="loading !== null"
            @click="ulcers = +!ulcers"
            :class="{ active: ulcers }"
            >
            Ulcers
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Vascular Disease'"
            :disabled="loading !== null"
            @click="vascularDisease = +!vascularDisease"
            :class="{ active: vascularDisease }"
            >
            Vascular Disease
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'Other Major Conditions'"
            :disabled="loading !== null"
            @click="other = +!other"
            :class="{ active: other }"
            >
            Other Major Conditions
          </b-button>
          <input
            type="submit"
            value="Continue"
            class="submitButton mt-3"
            :loading="loading === 'Continue'"
            :disabled="loading !== null"
          />
        </form>
      </div>
    </div>
  </div>
</template>
